/** LRU с ограничением количества записей и удерживаемого объёма. */
export class AvatarCache<T> {
    private readonly entries = new Map<string, { value: T; weight: number }>();
    private used = 0;

    constructor(private readonly maxEntries: number, private readonly maxWeight: number) {}

    get size(): number { return this.entries.size; }
    get weight(): number { return this.used; }
    keys(): IterableIterator<string> { return this.entries.keys(); }
    get(key: string): T | undefined {
        const entry = this.entries.get(key);
        if (!entry) return undefined;
        this.entries.delete(key);
        this.entries.set(key, entry);
        return entry.value;
    }
    set(key: string, value: T, weight = 1): void {
        this.delete(key);
        if (weight > this.maxWeight) return;
        this.entries.set(key, { value, weight });
        this.used += weight;
        while (this.entries.size > this.maxEntries || this.used > this.maxWeight) {
            const oldest = this.entries.keys().next().value;
            if (oldest === undefined) break;
            this.delete(oldest);
        }
    }
    delete(key: string): void {
        const entry = this.entries.get(key);
        if (entry) this.used -= entry.weight;
        this.entries.delete(key);
    }
    clear(): void { this.entries.clear(); this.used = 0; }
}
